module.exports = __webpack_public_path__ + "img/location.b15bffef.svg";